import { callApi, callApiWithOptionalAuth } from 'api/utils'

import { PATHS } from './paths'
import { getTogetherPath } from './utils'

export const getPostListsByArticleId = async (
  id: string,
  sortBy = 'newest',
  isLogin = false,
) => {
  const callApiFn = isLogin ? callApiWithOptionalAuth : callApi
  return callApiFn(
    getTogetherPath(PATHS.POST.LIST, {
      articleId: String(id),
      sort: sortBy,
      page: 1,
      ignoreCache: 1,
    }),
    'GET',
  )
}
